module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0004.jpg?v=e6e00849";